export const FacebookSocialLink = 'http://fb.com/cfoa.am/';
export const LinkedinSocialLink = 'https://www.linkedin.com/company/cfoa/';
export const TwitterSocialLink = 'https://twitter.com/cfoa_ngo';

export const SmallComputerScreen = 1440;
export const TabletScreen = 1024;
export const PhoneScreen = 720;